<template>
    <div class="content-wrapper">
        <!--<el-button @click="back()">返回</el-button>-->
        <div class="ibox-title">
            <h5>职工体检修改</h5>
        </div>
        <div class='worker_data ibox-content' style="padding-left: 0;">
            <div class="nav_cha">职工信息</div>
            <div>
                <el-form :inline="true" :model="formInline" :rules="rules" ref="formInline" label-width="94px" label-position="right" class="demo-form-inline">
                    <el-form-item label="幼儿园：" prop="gardenId" style="width:300px">
                        <el-select v-model="formInline.gardenId" filterable placeholder="请选择幼儿园" style="width:200px">
                            <el-option v-for="item in selectGarden" :key="item.orgID" :label="item.fullName" :value="item.orgID"  ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="姓名：" prop="teacherName" style="width:300px">
                        <el-input v-model="formInline.teacherName" placeholder="请输入姓名" style="width:200px"></el-input>
                    </el-form-item>
                    <el-form-item label="性别：" prop="teacherSex" style="width:300px">
                        <el-select v-model="formInline.teacherSex" placeholder="请选择性别" style="width:200px">
                            <el-option key="男" label="男" value="1"></el-option>
                            <el-option key="女" label="女" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="生日：" prop="teacherBirthday" style="width:300px">
                        <el-date-picker v-model="formInline.teacherBirthday" value-format='yyyy-MM-dd' type="date" placeholder="选择日期" style="width:200px"> </el-date-picker>
                    </el-form-item>
                    <el-form-item label="身份证号码：" prop="teacherIDCard" style="width:300px">
                        <el-input v-model="formInline.teacherIDCard" placeholder="请输入身份证号码" style="width:200px"></el-input>
                    </el-form-item>
                    <el-form-item label="婚否：" style="width:300px">
                        <el-select v-model="formInline.teacherMarry" style="width:200px">
                            <el-option key="未婚" label="未婚" value="未婚"></el-option>
                            <el-option key="已婚" label="已婚" value="已婚"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="岗位：" style="width:300px">
                        <el-input v-model="formInline.teacherPosition" placeholder="请输入岗位名称" style="width:200px"></el-input>
                    </el-form-item>
                    <el-form-item label="民族：" style="width:300px">
                        <el-select v-model="formInline.teacherNational" style="width:200px">
                            <el-option v-for="item in nationList" :key="item.code" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="手机号码：" prop='teacherTelPhone' style="width:300px">
                        <el-input v-model="formInline.teacherTelPhone" placeholder="请输入手机号" style="width:200px"></el-input>
                    </el-form-item>
                    <div class="nav_cha">体检信息</div>
                    <el-form-item label="体检日期：" prop='checkDate' style="width:300px">
                        <el-date-picker v-model="formInline.checkDate" value-format='yyyy-MM-dd' type="date" placeholder="选择体检日期" style="width:200px"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="体检单位：" style="width:300px">
                        <el-input v-model="formInline.hospital" placeholder="请输入体检单位" style='width: 200px;'></el-input>
                    </el-form-item>
                    <el-form-item label="主治医师：" style="width:300px">
                        <el-input v-model="formInline.doctor" placeholder="请输入主治医师" style='width: 200px;'></el-input>
                    </el-form-item>
                    <div v-for='item in CategoryList' :key="item.id">
                        <div class="nav_cha">{{item.categoryName}}</div>
                        <el-form-item v-for='val in detailList' :key="val.id" :label='val.itemName+"："' v-if='val.categoryId==item.id' style="width:400px">
                            <template v-for='(list,num) in staffMecItemList' v-if='list.itemId==val.id'>
                                <template v-if='val.unit'>
                                    <el-input v-if='val.valueType == 2 ||val.valueType == 1' v-model='list.itemResult' style="width:150px"></el-input>
                                    <span>{{val.unit}}</span>
                                </template>
                                <template v-else>
                                    <template v-if="val.valueType == 3">
                                        <template v-if="list.itemResult.indexOf('_') > 0">
                                            <el-select v-model="list.itemResult.split('_')[0]" :ref="val.id" style="width:150px" @change="customizeInput($event,list,val,val.id)">
                                                <template v-for='el in val.valueOptions.split(",")'>
                                                    <el-option :key='el' :label="el" :value='el'></el-option>
                                                </template>
                                            </el-select>
                                            <input :value="list.itemResult.split('_')[1]" class="el-input__inner" name="subValue" style="width: 150px;" @change="changeInp($event,val,num)">
                                        </template>
                                        <el-select v-else-if="list.itemResult.indexOf('_') <0" :ref="val.id" v-model='list.itemResult' style="width:150px" @change="customizeInput($event,list,val,val.id)">
                                            <template v-for='el in val.valueOptions.split(",")'>
                                                <el-option :key='el' :label="el" :value='el'></el-option>
                                            </template>
                                        </el-select>
                                    </template>
                                    <el-input v-if='val.valueType == 2 ||val.valueType == 1' v-model='list.itemResult' style="width:150px"></el-input>
                                </template>
                            </template>
                        </el-form-item>
                    </div>
                    <div class="nav_cha">检查结果（医院评定）</div>
                        <el-form-item class="evaluate">
                            <el-input type='textarea' :rows='5' v-model="formInline.checkResult"></el-input>
                        </el-form-item>
                    <div class="nav_cha">医生意见</div>
                        <el-form-item class="evaluate">
                            <el-input type='textarea' :rows='5' v-model="formInline.doctorSuggestion"></el-input>
                        </el-form-item>
                    <div class='hold' style="margin-top:20px">
                        <el-form-item>
                            <el-button class="btn-primary" type="primary" size='large' @click='submit(formInline)'>保存</el-button>
                        </el-form-item>
                    </div>
                </el-form>

            </div>

        </div>
    </div>
</template>
<script>
    import api from '../../com/ajax' // ajax请求封装
    import config from '../../com/config' // url配置文件
    export default {
      data () {
        return {
          tableData: [], // 数据表数据
          tableSelection: [], // 数据表选择数据集合
          tableSelectObj: {}, // 数据表单条选择数据对象
          tableSelectKey: '',
          tableLoading: false,
          formInline: {// 筛选条件表单数
            gardenId: '',
            teacherName: '',
            teacherSex: '',
            teacherBirthday: '',
            doctor: '',
            teacherTelPhone: '',
            teacherIDCard: '',
            itemResultList: [],
            checkDate: '',
            doctorSuggestion: '',
            checkResult: '',
            teacherMarry: '',
            teacherPosition: '',
            hospital: '',
            teacherNational: ''
          },
          gardenId: '',
          dataSub: {},
          opt: '',
          itemResult: '',
          selectGarden: [], // 幼儿园列表
          nationList: [], // 民族列表
          diseaseListL: [],
          detailList: [], // 检查项目
          staffMecItemList: [],
          CategoryList: [], // 检查项目模块
          valueOptions: '',
          findArr: [],
          rules: {
            gardenId: [
                        { required: true, message: '请输入幼儿园名称', trigger: 'blur' }
            ],
            teacherName: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
            ],
            teacherSex: [
                        { required: true, message: '请选择性别', trigger: 'blur' }
            ],
            teacherBirthday: [
                        { required: true, message: '请选择生日', trigger: 'blur' }
            ],
            teacherIDCard: [
                        { required: false, trigger: 'blur' },
                        { pattern: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/, message: '身份证号码输入格式不正确。', trigger: 'blur'}
            ],
            checkDate: [
                        { required: true, message: '请选择体检日期', trigger: 'blur' }
            ],
            teacherTelPhone: [
                        { required: false, trigger: 'blur' },
                        { pattern: /^1(3|4|5|7|8)\d{9}$/, message: '手机号码格式错误', trigger: 'blur' }
            ]
          }
        }
      },
      methods: {
        back () {
          var list = this.formInline
          for (var i in list) {
            list[i] = ''
          };
          this.$refs.formInline.resetFields()
          this.$emit('close', false, true)
        },
        customizeInput (val, list, data, id) {
          var that = this
          var dom = that.$refs[id][0].$el.offsetParent
          var input = document.createElement('input')
          input.className = 'el-input__inner'
          input.style.width = '150px'
          input.onchange = function (event) {
            data.valueN = event.path[0].value
          }
          delete data.valueN
          if (val === data.subValue) {
            var exist = false
            var num = 0
            dom.childNodes.forEach(function (i) {
              num++
              if (i.className === 'el-input__inner') {
                exist = true
              }
            })
            if (num === dom.childNodes.length && exist === false) {
              dom.append(input)
            }
          } else {
            let exist = false
            let allNum = 0
            let num = 0
            dom.childNodes.forEach(function (i, index) {
              allNum++
              if (i.className === 'el-input__inner') {
                exist = true
                num = index
              }
            })
            if (allNum = dom.childNodes.length && exist === true) {
              dom.removeChild(dom.childNodes[num])
            }
          }
          list.itemResult = val
        },
        changeInp (event, data, num) {
          data.valueN = event.path[0].value
          this.staffMecItemList[num].itemResult = this.staffMecItemList[num].subValue + '_' + event.path[0].value
        },
        submit (formInline) { // 提交
          var that = this
          that.$refs.formInline.validate((valid) => {
            if (valid) {
              formInline.itemResultList = []
              for (var i = 0; i < that.detailList.length; i++) {
                var param1 = {}
                param1.itemId = ''
                param1.itemResult = ''
                if (!that.detailList[i].defaultValue) {
                  that.detailList[i].defaultValue = ''
                }
                param1.itemId = that.detailList[i].id
                if (that.detailList[i].valueN !== '' && that.detailList[i].valueN !== undefined) {
                  param1.itemResult = that.staffMecItemList[i].itemResult + '_' + that.detailList[i].valueN
                } else {
                  if (that.staffMecItemList[i].itemResult === '异常') {
                    param1.itemResult = that.staffMecItemList[i].itemResult + '_'
                  } else {
                    param1.itemResult = that.staffMecItemList[i].itemResult
                  }
                }
                // else if (that.staffMecItemList[i].itemResult !== undefined && that.staffMecItemList[i].itemResult.indexOf('_') > 0) {
                //   param1.itemResult = that.staffMecItemList[i].itemResult
                // }
                var val = param1.itemResult
                var maxValue = that.detailList[i].maxValue
                var minValue = that.detailList[i].minValue
                var decimalPlace = that.detailList[i].decimalPlace
                var itemName = that.detailList[i].itemName
                var valueType = that.detailList[i].valueType
                if ((maxValue !== '' && parseFloat(val) > parseFloat(maxValue)) || (minValue !== '' && parseFloat(val) < parseFloat(minValue))) {
                  that.$message({
                    message: itemName + '：输入值超出[' + minValue + ', ' + maxValue + ']范围'
                  })
                  return false
                }
                var reg = /^[0-9]+.?[0-9]*$/
                if (itemName === '丙氨酸氨基转移酶' && valueType === 1 && val !== '' && !reg.test(val)) {
                  that.$message({
                    message: '丙氨酸氨基转移酶的数值不正确，请输入正确的数值类型。'
                  })
                  return false
                }
                if (itemName === '丙氨酸氨基转移酶' && val !== '' && decimalPlace && decimalPlace !== '') {
                  var reg1 = new RegExp('^\\+?(\\d*\\.\\d{0,' + decimalPlace + '})$')
                  if (!reg1.test(val)) {
                    that.$message({
                      message: '请输入' + itemName + '体检项结果的小数位为：' + decimalPlace + '位！'
                    })
                    return false
                  }
                }
                formInline.itemResultList.push(param1)
              }
              api.post(config.host + 'staffMec/updateStaffMECInfo.do', formInline).then(function (response) {
                if (response.success === true) {
                  that.$message({
                    message: '更新成功', iconClass: 'tipclass', customClass: 'tipcustomClass'
                  })
                  that.back()
                }
              })
            }
          })
        },
        getData (url, param, key, hasData) {
          var that = this
          api.post(config.host + url, param).then(function (response) {
            if (hasData && hasData === true) {
              response.body.list.forEach(function (ele) {
                that[key].push(ele)
              })
            } else {
              that[key] = response.body.list
            }
          })
        },
        // 格式化成Map
        formatMap (data, key, childKey) {
          let cusMKeys
          if (childKey && childKey.length > 0) {
            cusMKeys = {
              data: new Object(), // 所有集合
              dataHC: new Array(), // 有子项的集合
              get: function (key) {
                return this.data[key]
              },
              set: function (key, value) {
                let itemPro = this.get(key)
                if (itemPro === undefined) {
                  this.data[key] = value
                  if (this.data[key][childKey] && this.data[key][childKey] !== '0') {
                    this.dataHC.push(value)
                  }
                }
              },
              remove: function (key) { // 移除某项值
                if (data[key]) {
                  delete data[key]
                }
              }
            }
          } else {
            cusMKeys = {
              data: Array(),
              get: function (key) {
                return this.data[key]
              },
              set: function (key, value) {
                if (this.get(key) === undefined) {
                  // this.data[key] = value
                  // 当功能只有一个子集时，为对象；功能有多个子集时生成了数组，导致解析失败
                  // 2018-6-8 代曦
                  this.data[key] = []
                  this.data[key].push(value)
                } else {
                  if (this.data[key] instanceof Array) {
                    this.data[key].push(value)
                  } else {
                    var arr = new Array()
                    arr.push(this.get(key))
                    arr.push(value)
                    this.data[key] = arr
                  }
                }
              }
            }
          }
          $.each(data, function (i, item) {
            cusMKeys.set(item[key], item)
          })
          return cusMKeys
        }
      },
      created () {
        var that = this
        // 获取幼儿园列表
        api.post(config.host + 'orgkind/getGardenListByOrganId.do').then(function (json) {
          that.selectGarden = json.body.list
        })
        // 获取民族列表
        that.getData('common/getDictByName.do', { name: 'national' }, 'nationList')
        // 获取检查项目模块
        api.post(config.host + 'staffMec/getCategoryList.do').then(function (data) {
          that.CategoryList = data.body
            // 获取检查项目模块
          api.post(config.host + 'staffMec/getItemDetailList.do').then(function (json) {
            that.detailList = json.body
            var param = {}
            param.id = that.$route.params.id
            api.post(config.host + 'staffMec/getStaffMECResultByMecId.do', param).then(function (response) {
              that.formInline = response.body
              var oldStaffMecItemList = response.body.staffMecItemList
              that.staffMecItemList = []
              that.detailList.forEach(function (i) {
                var obj = {
                  'categoryId': i.categoryId,
                  'id': i.id,
                  'itemName': i.itemName,
                  'itemId': i.id,
                  'staffMecId': '',
                  'itemResult': i.defaultValue || ''
                }
                oldStaffMecItemList.forEach(function (j, index) {
                  if (i.id === j.itemId) {
                    obj.itemResult = j.itemResult
                    obj.staffMecId = j.staffMecId
                    return false
                  };
                })
                that.staffMecItemList.push(obj)
              })
            })
          })
        })
      }
    }
</script>
<style>

    .nav_cha {
        padding-left: 10px;
        border-left: 5px solid #1ab394;
        height: 16px;
        line-height: 16px;
        margin: 12px;
        font-weight: bold;
        text-align: left;
    }

    .red {
        color: red;
        position: relative;
        left: 30px;
        top: 10px
    }

    .red1 {
        color: red;
        position: relative;
        left: 15px;
        top: 10px
    }

    .red2 {
        color: red;
        position: relative;
        top: 10px
    }

    .float {
        position: absolute;
        bottom: 0px;
        right: -45px;
    }

    .evaluate {
        width: 80%;
        margin-left: 27px;
    }

    .evaluate .el-form-item__content{
        width: 100%;
    }

    .hold {
        margin: auto;
        width: 200px;
    }
</style>


// WEBPACK FOOTER //
// src/components/physical/teacherPhyEdit.vue